/**
 * Generates callback to show popover record
 *
 * @param {object} params
 * @param {function} params.showRecordPopover - Callback to show record popover
 * @param {function} params.recordsShowPopover - Callback to show report popover
 * @param {function} params.recordsShowRecord - Callback to show record popover
 * @param {function} params.onOrderPress - Callback to show order information
 *
 * @returns {function} - Callback = A function to be called when item is pressed
 */

export function generateOnRecordPress({
  showRecordPopover,
  recordsShowPopover,
  recordsShowRecord,
  onOrderPress,
}: any) {
  return ({id}: any) =>
    showRecordPopover([id], {
      recordsShowPopover,
      recordsShowRecord,
      onOrderPress,
    });
}
